<template>
  <div>
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print" class="printContent">
      <div v-for="item in inStockBill" :key="item.pkid" class="printItemContainer">
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td rowspan="4" style="width: 130px">
                <div :id="'qrCode' + item.billNo" align="center"/>
              </td>
              <td colspan="2" style="font-weight: 700; font-size: 12pt" align="center">入库单</td>
            </tr>
            <tr>
              <td>入库单号：<span class="font-number">{{item.billNo}}</span></td>
              <td>入库类型：{{item.inStockTypeName}}</td>
            </tr>
            <tr>
              <td>关联单号：<span class="font-number">{{item.relBillNo}}</span></td>
              <td>收货时间：<span class="font-number">{{item.requireDate}}</span></td>
            </tr>
            <tr>
              <td>客戶编号：<span class="font-number">{{item.customerNo}}</span></td>
              <td>客户名称：{{item.customerName}}</td>
            </tr>
            <tr>
              <td colspan="3">备注：{{item.note}}</td>
            </tr>
          </table>
        </div>
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td align="center">
                {{item.inStockType === 1 || item.inStockType === 4 || item.inStockType === 9 || item.inStockType === 11 ? '生产订单' :
                  item.inStockType === 8 ? '客户编号' :
                  item.inStockType === 10 ? '采购订单号' :
                  '订单号'}}
              </td>
              <td>物料号</td>
              <td align="center" width="160px">物料名称</td>
              <td align="center">规格型号</td>
              <td align="center">库存仓位</td>
              <td align="center">所属仓位</td>
              <td align="center">入库数量</td>
            </tr>
            <tr v-for="i in item.details" :key="i.pkid">
              <td align="center" class="font-number">
                {{item.inStockType === 1 || item.inStockType === 4 || item.inStockType === 9 || item.inStockType === 11 ? i.productionOrderNo :
                  item.inStockType === 8 ? i.customerNo :
                  item.inStockType === 10 ? i.purchaseOrder :
                  i.refBillNo}}
              </td>
              <td class="font-number">{{i.materialNo}}</td>
              <td align="center">{{i.materialName}}</td>
              <td align="center" class="font-number">{{i.specification}}</td>
              <td align="center">{{i.warehouseNo}}</td>
              <td align="center">{{constant.locationNo[i.locationNo]}}</td>
              <td align="center" class="font-number">{{i.quantity}}</td>
            </tr>
          </table>
        </div>
        <div class="printInfo printItem">
          <div class="printPerson">打印人：{{printPerson}}</div>
          <div class="printTime">打印时间：{{printTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from "qrcodejs2";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";

  export default {
    data() {
      return {
        constant,
        inStockBill: [],
        ids: [],
        printPerson: "",
        printTime: "",
      };
    },

    mounted() {
      // 初始化打印人（取当前登录的人）
      this.printPerson =  auth.getName();
      
      // 初始化打印时间（年-月-日格式）
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      this.printTime = `${year}-${month}-${day}`;
      
      this.getData(this.$route.query.params);
    },

    methods: {
      getData(ids) {
        this.ids = ids;
        this.$http.get("basic", `inStockBills/getAllListByIds/${ids}`).then((resp) => {
          this.inStockBill = resp.data;
          for (let item of this.inStockBill) {
            this.$nextTick(() => {
              document.getElementById("qrCode" + item.billNo).innerHTML = "";
              this.bindQRCode(item.billNo);
            });
          }
        });
      },

      bindQRCode(code) {
        new QRCode(document.getElementById("qrCode" + code), {
          text: code,
          width: 110,
          height: 110,
          colorDark: "#000000", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss" scoped>
.printBtnBox {
  width: 195mm; margin: 0 auto; padding: 2mm 0; position: fixed; top: 0; left: -10cm; margin-left: 50%;background-color: #fff;z-index: 999;
}
.printItem {
  width: 195mm;
  border: 1px solid #000;
  font-size: 11pt;
  margin: 10px auto 5px;
  color: #000;
  font-weight: 600;
  font-family: '楷体','SimSun', '宋体';
  line-height: 1.2;
  word-break: break-all;
  position: relative;
  .font-number{
    font-family: 'Courier New', monospace;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000;
    tr {
      td {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 2px;
        word-break: break-all;
        &:last-child {
          border-right: none;
        }
      }

      &:last-child td {
        border-bottom: none;
      }
    }
  }
}
.printContent {
  padding-top: 50px;
  margin-bottom: 10px;
}

.printInfo {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  border: none;
}
@media print {
  .printItemContainer {
    margin: 0;
    page-break-inside: avoid; // 避免在打印项内部分页
  }
  .printItem{
    margin: 0;
  }
  // 只在打印项之间添加分页符，而不是在最后一个打印项之后
  .printItemContainer:not(:last-child) {
    page-break-after: always;
  }
  .printBtnBox{
    display: none;
  }
  .printContent {
    padding-top: 0;
  }
}
</style>
